import axios from '@/http.js';
import qs from 'qs';

export default {
  getTagsList(params, headers) {
    return axios({
      method: 'get',
      url: 'api/tag',
      params,
      headers,
      paramsSerializer: params => {
          return qs.stringify(params, {indices: false});
      },
    })
  },
  addTag(data) {
    const url = `/api/tag`;
    return axios.post(url, data);
  },
  delTag(data) {
    const url = `/api/tag/delete?id=${data.id}`
    return axios.delete(url)
  }
}